<template>
  <NButtonToggleGroup
    v-model="selectedFilterIndex"
    v-gid="{
      module: 'orderTables',
      screen: 'home',
      section: 'ordersOptionPositionTable',
      component: 'ordersOptionPositionTableToggle',
    }"
    color="gray"
    dir="rtl"
    class="flex items-start my-1 mx-1"
  >
    <NButtonToggle
      v-for="{ label, value } in ORDER_FILTER_OPTIONS"
      :key="value"
      v-gid="{
        module: 'orderTables',
        screen: 'home',
        section: `${value}OrderTab`,
        component: `${value}OrderTableTab`,
      }"
      :label="label"
    />
  </NButtonToggleGroup>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { ORDER_FILTER_OPTIONS } from '../constants';

type PositionTableTabToggleProps = {
  positionOrderType: string;
};

type PositionTableTabToggleEmits = {
  (e: 'update:positionOrderType', value: string): void;
};

const props = defineProps<PositionTableTabToggleProps>();
const emit = defineEmits<PositionTableTabToggleEmits>();

const selectedFilterIndex = computed({
  get: () => {
    const index = ORDER_FILTER_OPTIONS.findIndex(
      (filter) => filter.value === props.positionOrderType
    );

    return index === -1 ? 0 : index;
  },
  set: (index: number) => {
    emit('update:positionOrderType', ORDER_FILTER_OPTIONS[index].value);
  },
});
</script>
